import React from 'react';
import Pill from '@/components/ui/Pill';
import AIBadge from '@/components/shared/AIBadge';
import { CorrelationSource } from '../types';

const SOURCE_COLORS: Record<Exclude<CorrelationSource, 'ai'>, string> = {
  edgate: 'blue',
  tci: 'grey',
};

interface SourceBadgeProps {
  label: string;
  source: CorrelationSource;
}

const SourceBadge = ({ label, source }: SourceBadgeProps) => {
  // AIBadge is icon-only and carries its own aria-label, so `label` is intentionally unused here.
  if (source === 'ai') return <AIBadge />;

  return (
    <Pill pillClassName="tw-text-xs tw-font-semibold tw-whitespace-nowrap" pillColor={SOURCE_COLORS[source]}>
      {label}
    </Pill>
  );
};

export default SourceBadge;
